/**
 * « Le dentiste fixe le prix » (AJ-02, demandé par le TL le 28/10, derrière
 * `FONCTION_PRIX_DENTISTE`).
 *
 * Chez le dentiste, le prix d'un patient non couvert dépend des soins faits :
 * il ne se connaît qu'après la consultation. Le patient entre donc dans la
 * file sans passer par la caisse ; le dentiste saisit le montant et les
 * prestations réalisées, encaisse le patient au box, puis remet l'argent à la
 * caisse, qui imprime le reçu de ce montant.
 */
import { memePrestation } from './boxes.js';
/** La seule prestation dont le praticien fixe le prix. */
export const PRESTATION_PRIX_DENTISTE = 'DENTISTE';
/** Au-delà, une liste de prestations n'est plus lisible sur un reçu. */
export const PRESTATIONS_REALISEES_MAX = 20;
/** Une prestation dont le prix se fixe au box, après la consultation. */
export function prixFixeParLeDentiste(prestation) {
    return memePrestation(prestation, PRESTATION_PRIX_DENTISTE);
}
/**
 * Les prestations réalisées, telles que le reçu les imprime : sans blancs
 * autour, sans ligne vide, sans doublon (la casse ne distingue pas deux soins).
 */
export function nettoyerPrestationsRealisees(prestations) {
    const propres = [];
    for (const brute of prestations) {
        const p = brute.trim().replace(/\s+/g, ' ');
        if (p !== '' && !propres.some((q) => q.toUpperCase() === p.toUpperCase()))
            propres.push(p);
    }
    return propres;
}
//# sourceMappingURL=prix-dentiste.js.map